import {
  Component,
  HostListener,
  AfterViewInit,
  OnInit,
  inject
} from '@angular/core';
import {
  FilterListComponent,
  FilterSelectionAction,
} from 'gung-list';
import { AuthService, Product } from 'gung-standard';
import { first } from 'rxjs';

@Component({
  selector: 'app-hl-product-list',
  templateUrl: './hl-product-list.component.html',
  styleUrls: ['./hl-product-list.component.css'],
  standalone: false
})
export class HlProductListComponent extends FilterListComponent<Product> implements AfterViewInit, OnInit {
  protected authService = inject(AuthService);

  private smallScreeenWidth = 576;
  private currentLayout = 0;
  isSmallScreeen = false;

  isSales = false;

  ngOnInit(): void {
    super.ngOnInit();
    this.authService.getHasRoles('SALES').pipe(first())
      .subscribe((isSales) => {
        this.isSales = isSales;
      })
  }

  ngAfterViewInit(): void {
    /*const layouts = this.configService.getLayouts();
    if (this.isSales && window.innerWidth < this.smallScreeenWidth) {
      this.currentLayout = 1;
      this.isSmallScreeen = true;
    }
    const toRender = layouts[this.currentLayout];
    this.renderLayout(toRender.getListLayoutComponent(), toRender.getListItemComponent());*/

    const layouts = this.configService.getLayouts();
    this.currentLayoutIdx = this.defaultLayout || 0;
    if (this.isSales && window.innerWidth < this.smallScreeenWidth) {
      this.currentLayoutIdx = 1;
      this.isSmallScreeen = true;
    }
    const toRender = layouts[this.currentLayoutIdx];
    this.inicializeItemsPerRow();
    this.dynamicColumns = this.configService.getDynamicColumns ? this.configService.getDynamicColumns() : [];

    // This set timeout is important and required to fix an issue when changing between lists on the same page
    // such as on the customer page. Without this it would set the other lists search the first time it loaded (only in
    // the searchbar, but not actually doing the filter). This will make the rendering done after so that it is not seen.
    setTimeout(() => {
      this.renderLayout(toRender.getListLayoutComponent(), toRender.getListItemComponent());
    }, 0);
  }

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    if (!this.isSales) {
      return;
    }
    const windowObject = event.target || window;
    this.isSmallScreeen = windowObject.innerWidth < this.smallScreeenWidth;
    if (this.isSmallScreeen && this.currentLayout !== 1) {
      this.changeLayout(1);
      this.currentLayout = 1;
    }
  }

  setMultipleSelections(actions: FilterSelectionAction[]) {
    super.setMultipleSelections(actions);
    this.renderFilters = JSON.parse(JSON.stringify(this.renderFilters)); // Force to refresh the headr and filters
  }
}
